import { isUndefined } from '@borg/utils';

export default defineNuxtRouteMiddleware(async (to) => {
  const layout = useLayout();

  layout.value.showHeader = isUndefined(to.meta.showHeader) ? true : !!to.meta.showHeader;
  layout.value.showFooter = isUndefined(to.meta.showFooter) ? true : !!to.meta.showFooter;
});
